import React, { useState, useEffect } from 'react';
import { Search, Home, PlaySquare, Compass, Film, Gamepad2 } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import NotificationsDropdown from './NotificationsDropdown';



interface HeaderProps {
  currentTab?: string;
  onSelectTab?: (tab: string) => void;
  onSearch?: (query: string) => void;
  onSelectVideo?: (videoId: string) => void;
  hideSearch?: boolean;
}

export default function Header({ currentTab, onSelectTab, onSearch, onSelectVideo, hideSearch }: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [searchTerm, setSearchTerm] = useState('');
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    const handleScroll = () => setIsScrolled(window.scrollY > 50);

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setSearchTerm('');
    if (onSearch) onSearch('');
  }, [currentTab, location.pathname]);

  const isShortsActive = currentTab === 'shorts' || location.pathname.includes('/shorts');
  if (isShortsActive) {
    return null;
  }

  const menuItems = [
    { label: 'Página Inicial', tab: 'inicio', path: '/' },
    { label: 'PlayFeed', tab: 'playfeed', path: '/playfeed' },
    { label: 'Shortsplay', tab: 'shorts', path: '/shorts' },
    { label: 'Filmes', tab: 'filmes', path: '/filmes' },
    { label: 'Games', tab: 'games', path: '/games' },
  ];

  const handleMenuClick = (item: { tab: string; path: string }) => {
    setSearchTerm('');
    if (onSearch) onSearch('');
    if (onSelectTab) onSelectTab(item.tab);
    navigate(item.path);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchTerm(val);
    if (onSearch) onSearch(val);
  };

  return (
    <header style={{ 
      position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000, 
      backgroundColor: isScrolled ? '#000000' : 'rgba(0, 0, 0, 0.85)',
      backdropFilter: 'blur(10px)', borderBottom: '1px solid rgba(255,255,255,0.1)', boxSizing: 'border-box'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        
       <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => handleMenuClick(menuItems[0])}>
          <img 
            src="/favicon.png" 
            alt="Logo Doisplay" 
            style={{ height: '42px', width: 'auto', objectFit: 'contain' }} 
          />
        </div>

        {/* Barra de Navegação Inferior (Apenas para Telemóvel) */}
     {/* Menu do Computador com Ícones e Textos */}
        {!isMobile && (
          <nav style={{ display: 'flex', gap: '22px', alignItems: 'center' }}>
            {menuItems.map((item, index) => {
              const isActive = currentTab === item.tab || location.pathname === item.path;
              
              // Atribuir o ícone correto para cada aba no PC
              let IconComp = Home;
              if (item.tab === 'playfeed') IconComp = PlaySquare;
              if (item.tab === 'shorts') IconComp = Compass;
              if (item.tab === 'filmes') IconComp = Film;
              if (item.tab === 'games') IconComp = Gamepad2;

              return (
                <div 
                  key={index} 
                  onClick={() => handleMenuClick(item)}
                  style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: isActive ? '#fff' : '#aaa', 
                    fontSize: '12px', 
                    fontWeight: isActive ? '700' : '500',
                    cursor: 'pointer', 
                    letterSpacing: '0.5px', 
                    borderBottom: isActive ? '2px solid #E50914' : '2px solid transparent',
                    paddingBottom: '4px', 
                    transition: 'color 0.2s'
                  }}
                >
                  <IconComp size={16} strokeWidth={isActive ? 2.5 : 1.8} />
                  <span>{item.label.toUpperCase()}</span>
                </div>
              );
            })}
          </nav>
        )}

        {/* Lupa oculta apenas na Página Inicial, visível nas outras abas */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {!hideSearch && location.pathname !== '/' && currentTab !== 'inicio' && (
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '4px', padding: '6px 10px' }}>
              <Search color="#aaa" size={16} />
              <input 
                type="text" 
                placeholder="Buscar..." 
                value={searchTerm} 
                onChange={handleSearchChange}
                style={{ background: 'transparent', border: 'none', color: '#fff', outline: 'none', marginLeft: '6px', fontSize: '13px', width: isMobile ? '100px' : '140px' }}
              />
            </div>
          )}

          <NotificationsDropdown onSelectVideo={onSelectVideo} />
        </div>

      </div>
    </header>
  );
}